<button type="button" class="fvs__trigger" [class.fvs__trigger--open]="isOpen"
        [class.fvs__trigger--empty]="!hasSelection" [title]="label" [attr.aria-label]="label"
        aria-haspopup="listbox" [attr.aria-expanded]="isOpen" (click)="toggleOpen()">
  <span class="fvs__summary">{{ summary }}</span>
  <svg class="fvs__chevron" viewBox="0 0 10 6" fill="none" aria-hidden="true">
    <path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</button>

<div class="fvs__panel" *ngIf="isOpen">
  <div class="fvs__search" *ngIf="searchable">
    <i class="fa fa-search" aria-hidden="true"></i>
    <input #search type="text" class="fvs__search-input" placeholder="Search" autocomplete="off"
           [attr.aria-label]="'Search ' + label" [ngModel]="query" (ngModelChange)="onQuery($event)" />
  </div>

  <div class="fvs__list" role="listbox" [attr.aria-multiselectable]="multiple">
    <button type="button" class="fvs__option" role="option"
            *ngFor="let option of rows; trackBy: trackByValue"
            [class.fvs__option--on]="isSelected(option)" [attr.aria-selected]="isSelected(option)"
            (click)="pick(option)">
      <span class="fvs__box" *ngIf="multiple" aria-hidden="true">
        <svg viewBox="0 0 12 12" fill="none">
          <path d="M2.5 6.2l2.4 2.4 4.6-5.1" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
                stroke-linejoin="round" />
        </svg>
      </span>
      <span class="fvs__option-label">{{ option.label }}</span>
      <i class="fa fa-check fvs__tick" *ngIf="!multiple && isSelected(option)" aria-hidden="true"></i>
    </button>

    <div class="fvs__note" *ngIf="!rows.length">
      {{ query ? 'Nothing matches "' + query + '"' : 'Nothing to choose from' }}
    </div>
    <div class="fvs__note" *ngIf="hiddenCount > 0">
      {{ hiddenCount }} more. Search to narrow the list.
    </div>
  </div>

  <div class="fvs__foot" *ngIf="multiple">
    <span class="fvs__count">{{ selectedCount ? selectedCount + ' selected' : 'Choose one or more' }}</span>
    <button type="button" class="fvs__link" *ngIf="selectedCount" (click)="clear()">Clear</button>
    <button type="button" class="fvs__link fvs__link--strong" (click)="close()">Close</button>
  </div>
</div>
